module.exports = __webpack_public_path__ + "static/media/fj80-landcruiser-2.bda0fce6.webp";